module.exports = __webpack_public_path__ + "img/seckill_bg.af33185.png";